import { createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) => createStyles({
  root: {
    marginBottom: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    marginBottom: theme.spacing(2),
  },
  dates: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  error: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  day: {
    flexBasis: '20%',
  },
  month: {
    flexBasis: '40%',
  },
  year: {
    flexBasis: '30%',
  },
  dayMenu: {
    height: theme.spacing(45),
  },
  yearMenu: {
    height: theme.spacing(45),
  },
});

export default styles;
